var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    viewBox: "0 0 12 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.487981 9.42833L8.73798 1.17833C9.38876 0.527555 10.4439 0.527555 11.0946 1.17833C11.7454 1.82911 11.7454 2.88422 11.0946 3.535L8.14798 6.48167C5.8698 8.75984 5.8698 12.4535 8.14798 14.7317L11.0946 17.6783C11.7454 18.3291 11.7454 19.3842 11.0946 20.035C10.4439 20.6858 9.38876 20.6858 8.73798 20.035L0.487981 11.785C0.175529 11.4725 2.86102e-06 11.0486 2.86102e-06 10.6067C2.86102e-06 10.1647 0.175529 9.74088 0.487981 9.42833Z",
    fill: "#858383"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.e4268e3d5245d8a43d19ad058b59d360.svg";
export { ForwardRef as ReactComponent };